import request from '@/utils/http';

export function getUserInfo() {
  return request({
    url: '/mall/user/getUserInfo',
    method: 'get'
  });
}

export function geMobtUserInfo() {
  return request({
    url: '/mall/user/getUserInfo',
    method: 'get',
    data: 'mob'
  });
}

export function findBalanceLog(params) {
  return request({
    url: '/mall/user/findBalanceLog',
    method: 'post',
    params
  });
}

// // 鏌ヨ
// export    function findIntegralListBySearch  (data) {
//   return request({
//      url: '/mall/integral/findIntegralListBySearch',
//     method: 'post',
//     data
//   });
// }
